import { createI18n } from 'vue-i18n';
import en from './i18n/en.json';
import zh from './i18n/zh.json';
import es from './i18n/es.json';

// 定义语言包
const messages = {
  en,
  zh,
  es,
};

// 创建 i18n 实例
const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: 'en', // 默认语言
  fallbackLocale: 'en', // 备用语言
  messages,
});

export default i18n;
